import InputTextOnly from "../../controls/InputTextOnly";
import type { CustomerAddress } from "../../../types/customers";

interface CustomerAddressesFormProps {
  billing_address?: CustomerAddress | null;
  shipping_address?: CustomerAddress | null;
}

export default function CustomerAddressesForm(props: CustomerAddressesFormProps) {
  const { billing_address, shipping_address } = props;
  const billing = billing_address ?? {};
  const shipping = shipping_address ?? {};

  return (
    <div className="p-4">
      <div className="space-y-3">
        <div>
          <p className="text-lg font-semibold">Billing Address</p>
          <div className="mt-3 grid grid-cols-1 gap-4 max-w-4xl">
            <div>
              <InputTextOnly
                label="Billing Address Line 1"
                name="line1"
                value={billing.line1 ?? ""}
                labelOn={true}
                disabled={true}
              />
            </div>
            <div>
              <InputTextOnly
                label="Billing Address Line 2"
                name="line2"
                value={billing.line2 ?? ""}
                labelOn={true}
                disabled={true}
              />
            </div>
          </div>
          <div className="mt-3 grid grid-cols-4 gap-4 max-w-4xl">
            <div>
              <InputTextOnly
                label="City"
                name="city"
                value={billing.city ?? ""}
                labelOn={true}
                disabled={true}
              />
            </div>
            <div>
              <InputTextOnly
                label="Province"
                name="province"
                value={billing.province ?? ""}
                labelOn={true}
                disabled={true}
              />
            </div>
            <div>
              <InputTextOnly
                label="State"
                name="state"
                value={billing.state ?? ""}
                labelOn={true}
                disabled={true}
              />
            </div>
            <div>
              <InputTextOnly
                label="Country"
                name="country_code"
                value={billing.country_code ?? ""}
                labelOn={true}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="pt-10">
          <p className="text-lg font-semibold">Shipping Address</p>
          <div className="mt-3 grid grid-cols-1 gap-4 max-w-4xl">
            <div>
              <InputTextOnly
                label="Billing Address Line 1"
                name="line1"
                value={shipping.line1 ?? ""}
                labelOn={true}
                disabled={true}
              />
            </div>
            <div>
              <InputTextOnly
                label="Billing Address Line 2"
                name="line2"
                value={shipping.line2 ?? ""}
                labelOn={true}
                disabled={true}
              />
            </div>
          </div>
          <div className="mt-3 grid grid-cols-4 gap-4 max-w-4xl">
            <div>
              <InputTextOnly
                label="City"
                name="city"
                value={shipping.city ?? ""}
                labelOn={true}
                disabled={true}
              />
            </div>
            <div>
              <InputTextOnly
                label="Province"
                name="province"
                value={shipping.province ?? ""}
                labelOn={true}
                disabled={true}
              />
            </div>
            <div>
              <InputTextOnly
                label="State"
                name="state"
                value={shipping.state ?? ""}
                labelOn={true}
                disabled={true}
              />
            </div>
            <div>
              <InputTextOnly
                label="Country"
                name="country_code"
                value={shipping.country_code ?? ""}
                labelOn={true}
                disabled={true}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
